import type { UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import type { PasswordRequirementsResponse } from "@jti/fe-common";

import { QUERY_KEYS } from "../../constants/queryKeys";
import { CasAuthApi } from "../../services";

export const usePasswordRules = (avoidRequest?: boolean): UseQueryResult<PasswordRequirementsResponse> => {
  return useQuery(
    [QUERY_KEYS.passwordRules, avoidRequest],
    () => {
      if (!avoidRequest) {
        return CasAuthApi.init().getPasswordRequirements();
      }
      return Promise.resolve({
        minLength: 0,
        minLowerCase: 0,
        minUpperCase: 0,
        minNumber: 0,
        minSymbol: 0,
        excludeUsername: false,
      });
    },
    { retry: false }
  );
};
